var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined } from "@mui/icons-material";
import { Box, Chip, Grid, LinearProgress, styled, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { USER_PROFILE_DATA } from "../../../api/url";
import { SuccessIconNew } from "../../../assets/images";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiButton, MuiPopup } from "../../../components";
import { LOCAL_STORAGE_KEYS, StatusEnum } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { deleteState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { isLoadingState } from "../../../utils/utils";
// import { PrintIcon, ShareIcon } from "../../spareIssue/assets";
import JournalDetails from "../components/JournalDetails";
import { CreateJournalDetailAPICall, getJournalHeaderAPI } from "../services/apiCalls";
import { JournalVoucherKeys, PopupType } from "../services/entity";
import { CrossSvgIcon, DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { systemColor } from "../../../theme/systemColor";
var MyImg = styled("img")(function (_ref) {
    var theme = _ref.theme;
    return {
        height: "48px",
        marginRight: "5px",
        width: "48px"
    };
});
var formateDdMm = function (item) {
    if (item < 10) {
        return "0".concat(item);
    }
    else {
        return item;
    }
};
var dateFormate = function (date) {
    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var objectDate = new Date(date);
    var d = objectDate.getDate();
    var month = monthNames[objectDate.getMonth()];
    var y = objectDate.getFullYear();
    var dd = formateDdMm(d);
    return "".concat(dd, " ").concat(month, ", ").concat(y);
};
export var CreateJournalVoucher = function () {
    var _a;
    var _searchParams$get, _getSearchByTypeList$, _GetJournalHeader$dat, _getSearchByTypeList$3, _popupContent$state$p, _popupContent$state$p2;
    var id = useParams().id;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var searchParams = useSearchParams()[0];
    var getSearchByTypeList = crud.getSearchByTypeList;
    var mode = (_searchParams$get = searchParams.get('mode')) !== null && _searchParams$get !== void 0 ? _searchParams$get : "add";
    var GetJournalHeader = useAppSelector(function (state) { return state.crud; }).GetJournalHeader;
    var _b = useState(getSearchByTypeList ? getSearchByTypeList === null || getSearchByTypeList === void 0 || (_getSearchByTypeList$ = getSearchByTypeList[0]) === null || _getSearchByTypeList$ === void 0 ? void 0 : _getSearchByTypeList$.Value : ''), filterType = _b[0], setFilterType = _b[1];
    var _c = useState({
        type: '',
        openSuccessPopup: false
    }), onSavePopup = _c[0], setOnSavePopup = _c[1];
    var userData = getLocalStorageItem(USER_PROFILE_DATA);
    var _d = useState(""), errorMessage = _d[0], setErrorMessage = _d[1];
    var _e = useState({
        openValidationPopup: false,
        popupType: ""
    }), state = _e[0], setState = _e[1];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var isDisabled = mode !== 'add' ? [StatusEnum.Cancelled].includes(GetJournalHeader === null || GetJournalHeader === void 0 || (_GetJournalHeader$dat = GetJournalHeader.data) === null || _GetJournalHeader$dat === void 0 || (_GetJournalHeader$dat = _GetJournalHeader$dat.Status) === null || _GetJournalHeader$dat === void 0 ? void 0 : _GetJournalHeader$dat.Name) : false;
    useEffect(function () {
        var _getSearchByTypeList$2;
        setFilterType(getSearchByTypeList === null || getSearchByTypeList === void 0 || (_getSearchByTypeList$2 = getSearchByTypeList[0]) === null || _getSearchByTypeList$2 === void 0 ? void 0 : _getSearchByTypeList$2.Value);
    }, [getSearchByTypeList === null || getSearchByTypeList === void 0 || (_getSearchByTypeList$3 = getSearchByTypeList[0]) === null || _getSearchByTypeList$3 === void 0 ? void 0 : _getSearchByTypeList$3.Value]);
    var step2 = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: 'Notes & attachments',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Transfer reasons (0/200 characters)',
                    placeholder: 'Enter reasons',
                    multiline: true,
                    md: 6,
                    minRows: 2,
                    labelTypographyProps: {
                        variant: 'h6',
                        color: '#8593A3'
                    }
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachments',
                    label: 'Add attachments',
                    placeholder: 'Upload Files',
                    disabled: isDisabled,
                    value: null,
                    inputProps: {
                        accept: 'application/*',
                        multiple: true
                    }
                    // uploadAttachmentRequest: { systemname: JournalVoucherKeys.AttachmentSystemName },
                    // uploadAttachmentAPI: uploadJournalVoucherAttachment,
                    // deleteAttachmentAPI: stockTransferRequisitionAttachmentDelete,
                }]
        }];
    var step1 = [{
            type: FormItemTypes.Custom,
            name: 'JournalDetails',
            columnSize: 12,
            element: JournalDetails,
            labelTypographyProps: {
                display: 'none'
            },
            validator: function (rows, state) {
                var error = undefined;
                if (!(rows !== null && rows !== void 0 && rows.length)) {
                    dispatch(showNotification({
                        isOpen: true,
                        message: 'Please add Journal details',
                        type: "error"
                    }));
                    return 'Please add Journal details';
                }
                // rows.find((r: ResponseObject) => {
                //     const errorField = Object.keys(JournalDetailMandatoryFields).find(field => (typeof r[field] !== 'number' && typeof r[field] !== 'boolean') && !r[field]);
                //     if (errorField) {
                //         error = {
                //             id: v4(),
                //             rowId: r.id,
                //             field: JournalDetailMandatoryFields[errorField],
                //             message: 'This field is required',
                //             value: r[errorField]
                //         }
                //     }
                //     return Boolean(errorField)
                // })
                return error;
            }
        }];
    var tabs = [{
            id: '0',
            label: 'General details',
            elements: step1
        }, {
            id: '1',
            label: 'Additional Info',
            elements: step2
        }];
    var onBackIconClick = function () {
        navigate('/journalVoucher');
        dispatch(deleteState({
            key: JournalVoucherKeys.journalRowData
        }));
        dispatch(deleteState({
            key: JournalVoucherKeys.GetJournalHeader
        }));
        dispatch(deleteState({
            key: JournalVoucherKeys.Get
        }));
    };
    var isSaveDisable = function () {
        var _crud$JournalVoucherK, _crud$JournalVoucherK2;
        var hasDisabledItem = (_crud$JournalVoucherK = crud[JournalVoucherKeys.journalRowData]) === null || _crud$JournalVoucherK === void 0 ? void 0 : _crud$JournalVoucherK.every(function (item) { return item.isDisabled; });
        if (hasDisabledItem) {
            return true;
        }
        else if (((_crud$JournalVoucherK2 = crud[JournalVoucherKeys.journalRowData]) === null || _crud$JournalVoucherK2 === void 0 ? void 0 : _crud$JournalVoucherK2.length) > 0) {
            return false;
        }
        else
            return true;
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "flex-start",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            width: '100%',
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: '',
                    columnSize: 0,
                    onClick: onBackIconClick,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small"
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: 'DisplayName',
                    value: 'New journal voucher',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }, mode !== 'add' ? {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function (_ref2) {
                        var value = _ref2.value;
                        return /*#__PURE__*/ React.createElement(Chip, {
                            label: value === null || value === void 0 ? void 0 : value.Status,
                            size: "small",
                            variant: "outlined",
                            sx: {
                                borderRadius: 2,
                                px: 1,
                                fontWeight: 'bold'
                            },
                            icon: /*#__PURE__*/ React.createElement(Box, {
                                id: "create-spare-status-box",
                                height: 8,
                                width: 8,
                                borderRadius: 10,
                                bgcolor: "gray"
                            })
                        });
                    }
                } : null, mode !== 'add' ? {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    xs: 12,
                    sm: true,
                    item: false,
                    justifyContent: {
                        xs: 'space-between',
                        sm: 'flex-end'
                    },
                    spacing: 0,
                    p: {
                        xs: 2,
                        sm: 0
                    },
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'Code',
                            label: 'DOC NO: ',
                            // children: GetJournalHeader?.data?.Code ?? '-',
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedOn',
                            label: 'DATE: ',
                            valueGetter: function (formValues, field) {
                                return dateFormate(formValues === null || formValues === void 0 ? void 0 : formValues.CreatedOn);
                            },
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }]
                } : null]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Quick Links',
                            disabled: true,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(CrossSvgIcon, {
                                style: {
                                    height: "20px",
                                    width: "20px"
                                }
                            }),
                            columnSize: 0,
                            variant: "outlined",
                            disabled: true,
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: 'saveAsDraft',
                            label: '',
                            value: null,
                            children: 'Save as draft',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            disabled: true
                        }, {
                            type: FormItemTypes.Button,
                            name: 'submit',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            color: 'primary',
                            disabled: isSaveDisable(),
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                }
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    var onClosePopup = function () {
        setState({
            openValidationPopup: false,
            popupType: ""
        });
    };
    var onCloseSuccessPopup = function () {
        setOnSavePopup({
            type: '',
            openSuccessPopup: false
        });
    };
    var onOkClick = function () {
        setState({
            popupType: "",
            openValidationPopup: false
        });
    };
    var popupContent = (_a = {},
        _a[PopupType.amountNotEqual] = {
            title: "Total Debit Amount Equals Total Credit Amount",
            message: "The total debit amount must be equal to the total credit amount before posting this journal entry."
        },
        _a[PopupType.error] = {
            title: "Validation Error",
            message: errorMessage
        },
        _a[PopupType.emptyArray] = {
            title: "Empty Record",
            message: "Please fill out all the required fields before saving."
        },
        _a[PopupType.Mandatory] = {
            title: "Mandatory Field",
            message: "Please select a contact for accounts marked as 'Maintain Contact Balance'."
        },
        _a[PopupType.amountMissing] = {
            title: "Missing Debit/Credit Amount",
            message: "Please enter either a debit or credit amount for the selected account."
        },
        _a[PopupType.contactMandatory] = {
            title: "Contact Selection for Certain Accounts",
            message: "Please select a contact for accounts marked as 'Maintain Contact Balance'."
        },
        _a[PopupType.accountMissing] = {
            title: "Missing Account Selection",
            message: "Please select an account to proceed with the journal entry."
        },
        _a);
    var onOpenPopup = function (e, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _value$JournalDetails, journalDetails, missingPersonIds, hasValidAmounts, totals;
        return __generator(this, function (_a) {
            console.log("value", value);
            journalDetails = (value === null || value === void 0 || (_value$JournalDetails = value.JournalDetails) === null || _value$JournalDetails === void 0 ? void 0 : _value$JournalDetails.length) > 0 ? value === null || value === void 0 ? void 0 : value.JournalDetails : value;
            // Check if all objects are completely empty
            if (journalDetails !== null && journalDetails !== void 0 && journalDetails.every(function (item) {
                var _Object$values;
                return (_Object$values = Object.values(item)) === null || _Object$values === void 0 ? void 0 : _Object$values.every(function (val) { return val === null || val === undefined || val === '' || val === 0; });
            })) {
                setState({
                    popupType: PopupType.emptyArray,
                    openValidationPopup: true
                });
                return [2 /*return*/, false];
            }
            // Check for empty JournalTypeId
            if (journalDetails !== null && journalDetails !== void 0 && journalDetails.some(function (item) { return !item.JournalTypeId; })) {
                setState({
                    popupType: PopupType.accountMissing,
                    openValidationPopup: true
                });
                return [2 /*return*/, false];
            }
            missingPersonIds = journalDetails === null || journalDetails === void 0 ? void 0 : journalDetails.reduce(function (acc, item, index) {
                var _crud$JournalVoucherK3;
                var journalTypeItem = (_crud$JournalVoucherK3 = crud[JournalVoucherKeys.JournalVoucherAccountList]) === null || _crud$JournalVoucherK3 === void 0 || (_crud$JournalVoucherK3 = _crud$JournalVoucherK3.data) === null || _crud$JournalVoucherK3 === void 0 ? void 0 : _crud$JournalVoucherK3.find(function (i) { return item.JournalTypeId === i.id; });
                // Adjusted condition to check if both values are missing
                if (journalTypeItem !== null && journalTypeItem !== void 0 && journalTypeItem.IsSubLedger && !(item !== null && item !== void 0 && item.PersonId) && !(item !== null && item !== void 0 && item.OrganizationId)) {
                    acc.push("Row ".concat(index + 1));
                }
                return acc;
            }, []);
            if ((missingPersonIds === null || missingPersonIds === void 0 ? void 0 : missingPersonIds.length) > 0) {
                setState({
                    popupType: PopupType.contactMandatory,
                    openValidationPopup: true
                });
                return [2 /*return*/, false];
            }
            hasValidAmounts = journalDetails === null || journalDetails === void 0 ? void 0 : journalDetails.every(function (item) { return (item.DebitAmount || item.CreditAmount) !== null && (item.DebitAmount || item.CreditAmount) !== undefined && (item.DebitAmount || item.CreditAmount) !== ''; });
            if (!hasValidAmounts) {
                setState({
                    popupType: PopupType.amountMissing,
                    openValidationPopup: true
                });
                return [2 /*return*/, false];
            }
            totals = journalDetails === null || journalDetails === void 0 ? void 0 : journalDetails.reduce(function (acc, current) {
                acc.DebitAmount += current.DebitAmount || 0;
                acc.CreditAmount += current.CreditAmount || 0;
                return acc;
            }, {
                DebitAmount: 0,
                CreditAmount: 0
            });
            if (totals.CreditAmount !== totals.DebitAmount) {
                setState({
                    popupType: PopupType.amountNotEqual,
                    openValidationPopup: true
                });
                return [2 /*return*/, false];
            }
            // Check for Remarks length exceeding 500 characters
            if (journalDetails !== null && journalDetails !== void 0 && journalDetails.some(function (item) {
                var _item$Remarks;
                return (item === null || item === void 0 ? void 0 : item.Remarks) && (item === null || item === void 0 || (_item$Remarks = item.Remarks) === null || _item$Remarks === void 0 ? void 0 : _item$Remarks.length) > 500;
            })) {
                setState({
                    popupType: PopupType.error,
                    openValidationPopup: true
                });
                setErrorMessage("Remarks should not exceed 500 characters.");
                return [2 /*return*/, false];
            }
            console.log("journalDetails", journalDetails);
            return [2 /*return*/, true]; // All validations passed
        });
    }); };
    var createAPI = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var isValid, _params$request, _params$request2, _GetJournalHeader$dat2, _GetJournalHeader$dat3, _userData$data2, _GetJournalHeader$dat4, totals, transactions, request, response, errorMessage_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, onOpenPopup(null, params === null || params === void 0 ? void 0 : params.request)];
                case 1:
                    isValid = _a.sent();
                    if (!isValid) return [3 /*break*/, 3];
                    console.log("params", params);
                    totals = params === null || params === void 0 || (_params$request = params.request) === null || _params$request === void 0 || (_params$request = _params$request.JournalDetails) === null || _params$request === void 0 ? void 0 : _params$request.reduce(function (acc, current) {
                        acc.DebitAmount += current.DebitAmount || 0;
                        acc.CreditAmount += current.CreditAmount || 0;
                        return acc;
                    }, {
                        DebitAmount: 0,
                        CreditAmount: 0
                    });
                    transactions = params === null || params === void 0 || (_params$request2 = params.request) === null || _params$request2 === void 0 || (_params$request2 = _params$request2.JournalDetails) === null || _params$request2 === void 0 || (_params$request2 = _params$request2.filter(function (item) { return !(item !== null && item !== void 0 && item.isDisabled); })) === null || _params$request2 === void 0 ? void 0 : _params$request2.map(function (item) {
                        var _userData$data;
                        return _objectSpread(_objectSpread(_objectSpread({}, (item === null || item === void 0 ? void 0 : item.DebitAmount) > 0 && {
                            DebitAmount: item === null || item === void 0 ? void 0 : item.DebitAmount
                        }), (item === null || item === void 0 ? void 0 : item.CreditAmount) > 0 && {
                            CreditAmount: item === null || item === void 0 ? void 0 : item.CreditAmount
                        }), {}, {
                            PersonId: item !== null && item !== void 0 && item.PersonId ? item === null || item === void 0 ? void 0 : item.PersonId : null,
                            OrganizationId: item !== null && item !== void 0 && item.OrganizationId ? item === null || item === void 0 ? void 0 : item.OrganizationId : null,
                            JournalTypeId: item === null || item === void 0 ? void 0 : item.JournalTypeId,
                            TenantChartOfAccountId: item === null || item === void 0 ? void 0 : item.TenantChartOfAccountId,
                            EntryType: item.DebitAmount > 0 ? "debit" : "credit",
                            IdentityId: userData === null || userData === void 0 || (_userData$data = userData.data) === null || _userData$data === void 0 ? void 0 : _userData$data.IdentityId,
                            Description: item === null || item === void 0 ? void 0 : item.Description
                        });
                    });
                    request = {
                        Name: mode === 'add' ? "JournalVoucher" : GetJournalHeader === null || GetJournalHeader === void 0 || (_GetJournalHeader$dat2 = GetJournalHeader.data) === null || _GetJournalHeader$dat2 === void 0 ? void 0 : _GetJournalHeader$dat2.Name,
                        DisplayName: mode === 'add' ? "Journal Voucher" : GetJournalHeader === null || GetJournalHeader === void 0 || (_GetJournalHeader$dat3 = GetJournalHeader.data) === null || _GetJournalHeader$dat3 === void 0 ? void 0 : _GetJournalHeader$dat3.DisplayName,
                        TenantId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ParentOrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        IdentityId: userData === null || userData === void 0 || (_userData$data2 = userData.data) === null || _userData$data2 === void 0 ? void 0 : _userData$data2.IdentityId,
                        TotalDebitAmount: totals.DebitAmount,
                        TotalCreditAmount: totals.CreditAmount,
                        Transactions: transactions,
                        IsNewRecord: mode === 'add' ? true : false,
                        JournalHeaderId: mode === 'add' ? null : GetJournalHeader === null || GetJournalHeader === void 0 || (_GetJournalHeader$dat4 = GetJournalHeader.data) === null || _GetJournalHeader$dat4 === void 0 ? void 0 : _GetJournalHeader$dat4.id
                    };
                    console.log("request", request);
                    return [4 /*yield*/, CreateJournalDetailAPICall({
                            request: request
                        })];
                case 2:
                    response = _a.sent();
                    if (response !== null && response !== void 0 && response.success) {
                        setOnSavePopup({
                            type: mode !== null && mode !== void 0 ? mode : "",
                            openSuccessPopup: true
                        });
                        return [2 /*return*/, {
                                success: response === null || response === void 0 ? void 0 : response.success
                            }]; // Return success status
                    }
                    else {
                        errorMessage_1 = response === null || response === void 0 ? void 0 : response.message;
                        setErrorMessage(errorMessage_1);
                        setState({
                            popupType: PopupType.error,
                            openValidationPopup: true
                        });
                        dispatch(showNotification({
                            isOpen: false,
                            message: "",
                            type: "error"
                        }));
                        return [2 /*return*/, {
                                success: false,
                                message: errorMessage_1
                            }]; // Return failure status
                    }
                    return [3 /*break*/, 4];
                case 3:
                    console.log("Validation failed. API not called.");
                    return [2 /*return*/, {
                            success: false,
                            message: "Validation failed"
                        }]; // Return failure due to validation
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState([JournalVoucherKeys.Get]) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        getFormAPI: getJournalHeaderAPI,
        getRequest: {
            id: id
        },
        getKey: JournalVoucherKeys.GetJournalHeader,
        mode: mode,
        createFormAPI: createAPI,
        updateFormAPI: createAPI
    })), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: state.openValidationPopup,
        title: ((_popupContent$state$p = popupContent[state.popupType]) === null || _popupContent$state$p === void 0 ? void 0 : _popupContent$state$p.title) || "",
        variant: "h1",
        closeIcon: true,
        backdropEnable: true,
        onClose: onClosePopup
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        gap: 1,
        display: "flex"
    }, /*#__PURE__*/ React.createElement(Typography, {
        fontWeight: 600,
        id: "validation-messages",
        variant: "h3"
    }, "Message: "), /*#__PURE__*/ React.createElement(Typography, {
        id: "validation-title",
        variant: "h4"
    }, ((_popupContent$state$p2 = popupContent[state.popupType]) === null || _popupContent$state$p2 === void 0 ? void 0 : _popupContent$state$p2.message) || "")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        mt: 2,
        xs: 12,
        display: "flex",
        justifyContent: "center"
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        id: "ok-button",
        color: "primary",
        name: "OK",
        onClick: onOkClick
    })))), /*#__PURE__*/ React.createElement(MuiPopup, {
        openPopup: onSavePopup === null || onSavePopup === void 0 ? void 0 : onSavePopup.openSuccessPopup,
        title: /*#__PURE__*/ React.createElement(Box, {
            id: "success-box",
            display: "flex",
            alignItems: "center"
        }, /*#__PURE__*/ React.createElement(MyImg, {
            id: "success-icon",
            src: SuccessIconNew,
            alt: "settingIcon"
        }), /*#__PURE__*/ React.createElement(Typography, {
            id: "success-title",
            variant: "h1"
        }, (onSavePopup === null || onSavePopup === void 0 ? void 0 : onSavePopup.type) === "add" ? "Saved Successfully!" : "Updated Successfully!")),
        variant: "h1",
        closeIcon: false,
        backdropEnable: true,
        onClose: function () { return onCloseSuccessPopup(); }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        spacing: 2,
        p: 2,
        sx: {
            textAlign: 'center',
            backgroundColor: '#f9f9f9'
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        id: "success-message",
        fontWeight: 500
    }, (onSavePopup === null || onSavePopup === void 0 ? void 0 : onSavePopup.type) === "add" ? "Your new journal has been saved successfully." : "The journal has been updated successfully.")), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        mt: 2
    }, /*#__PURE__*/ React.createElement(MuiButton, {
        variant: "contained",
        color: "primary",
        id: "success-button",
        name: t("Go to homepage"),
        onClick: function () { return navigate("/journalVoucher"); }
    })))));
};
